module.exports = __webpack_public_path__ + "./assets/img_ximen_grey__630cc511948b71ec1ffe5c53f485ece6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_ximen_grey.jpg
// module id = 602
// module chunks = 12